import React from 'react';
import CookieConsentBanner from './src/components/gdpr/CookieConsentBanner';
import { loadGoogleAnalytics } from './src/util/analytics';

export const onClientEntry = () => {
  // For returning visitors: check existing consent cookie and load GA immediately
  const cookies = document.cookie.split('; ');
  const consentCookie = cookies.find((c) => c.startsWith('cookie-consent='));
  if (consentCookie) {
    const value = decodeURIComponent(consentCookie.split('=')[1]);
    if (value.includes('analytics')) {
      loadGoogleAnalytics();
    }
  }
};

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0);
  return false;
};

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieConsentBanner />
  </>
);

